import { CancelToken } from 'api';
import { del, get, post, put } from 'features/api';
import { CompareListRequest, CompareLists, CompareListStatus } from '../types';

export const getLists = (customerId: string, customHost: string, cancelToken?: CancelToken) => {
  return get<CompareLists>(
    'lists',
    { customerId },
    {
      headers: {
        'Content-Type': 'application/json;charset=UTF-8',
      },
      cancelToken,
    },
    customHost,
  );
};

export const createList = (body: CompareListRequest, customHost: string, cancelToken?: CancelToken) => {
  return post<CompareListStatus>(
    'list',
    body,
    {
      headers: {
        'Content-Type': 'application/json;charset=UTF-8',
      },
      cancelToken,
    },
    undefined,
    customHost,
  );
};

export const putList = (body: CompareListRequest, customHost: string, cancelToken?: CancelToken) => {
  return put<CompareListStatus>(
    'list',
    body,
    {
      headers: {
        'Content-Type': 'application/json;charset=UTF-8',
      },
      cancelToken,
    },
    undefined,
    customHost,
  );
};

export const deleteList = (
  customerId: string,
  groupId: string | null,
  customHost: string,
  cancelToken?: CancelToken,
) => {
  return del<CompareListStatus>(
    'list',
    { customerId, groupId },
    {
      headers: {
        'Content-Type': 'application/json;charset=UTF-8',
      },
      cancelToken,
    },
    customHost,
  );
};
